export default __webpack_public_path__ + "static/media/evapotranspiration.ac38eaa7.png";